import XMLParserSingleton from "../../../XMLParserSingleton";

var iconv = require("iconv-lite");

/**
 * Converts XML string to JSON object using xml2js parser
 * @param xmlString The XML string to convert
 * @returns Promise<any> The parsed JSON object
 */
export async function convertXmlStringToJson(xmlString: string): Promise<any | undefined> {
  const options = {
    explicitChildren: true,
    preserveChildrenOrder: true,
    childkey: "items",
    attrkey: "a",
  };

  // const parser = new xml2js.Parser(options);
  // const data = await parser.parseStringPromise(xmlString);

  const parser = XMLParserSingleton.Instance;
  const data = parser.parse(xmlString);

  return data;
}

/**
 * Decodes filename using CP437 encoding (for ZIP file compatibility)
 * @param data The encoded data
 * @returns string The decoded filename
 */
export function decodeFileName(data: any): string {
  return iconv.decode(data, "CP437"); // no itx
}
